import axios from "axios"
import { Apis } from "constants/apis"
import { getToken } from "utils/token"

const logout = async() => {
    const { data } = await axios.get(Apis.LOGOUT, { headers: { Authorization: getToken() } })
    return data
}

export default logout